"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DAY_IN_MS = 1000 * 60 * 60 * 24;
var CalendarWeeks = /** @class */ (function () {
    function CalendarWeeks(year, month, firstWeekDay, hasStaticNumberOfWeek) {
        if (month < 0 || firstWeekDay < 0 || month > 11 || firstWeekDay > 6) {
            throw new Error('CalendarWeeks error: bad constructor arguments. Arguments "year", "month", "firstWeekDay" must be positive. Argument "month" must be 0-11, "firstWeekDay" must be 0-6');
        }
        this.year = year;
        this.month = month;
        this.firstWeekDay = firstWeekDay;
        this.hasStaticNumberOfWeek = !!hasStaticNumberOfWeek;
    }
    CalendarWeeks.prototype.getDates = function () {
        var i = 0;
        var startDate = this.getFirstWeekStartDate();
        var lastMonthWeekDate = this.getLastWeekEndDate();
        var currentDate = startDate;
        var dates = [];
        var numberOfDays = (lastMonthWeekDate.valueOf() - startDate.valueOf()) / DAY_IN_MS + 1;
        var diffToStaticNumberOfWeeks = 42 - numberOfDays;
        var lastDate = this.hasStaticNumberOfWeek && diffToStaticNumberOfWeeks > 0
            ? new Date(lastMonthWeekDate.getFullYear(), lastMonthWeekDate.getMonth(), lastMonthWeekDate.getDate() + diffToStaticNumberOfWeeks)
            : lastMonthWeekDate;
        while (currentDate <= lastDate) {
            i++;
            dates.push(currentDate);
            currentDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + i);
        }
        return dates;
    };
    CalendarWeeks.prototype.getDatesGroupedByWeek = function () {
        return this.getDates().reduce(function (acc, curr, idx) {
            var week = (idx - (idx % 7)) / 7;
            if (!acc[week]) {
                acc[week] = [];
            }
            acc[week].push(curr);
            return acc;
        }, []);
    };
    CalendarWeeks.prototype.getFirstMonthDayWeekPosition = function () {
        var firstMonthDay = new Date(this.year, this.month, 1);
        return this.getWeekDayPosition(firstMonthDay.getDay());
    };
    CalendarWeeks.prototype.getLastMonthDayWeekPosition = function () {
        var lastMonthDay = new Date(this.year, this.month + 1, 0);
        return this.getWeekDayPosition(lastMonthDay.getDay());
    };
    CalendarWeeks.prototype.getWeekDayPosition = function (weekDay) {
        var weekDayPosition = weekDay - this.firstWeekDay;
        if (weekDayPosition < 0) {
            weekDayPosition += 7;
        }
        return weekDayPosition;
    };
    CalendarWeeks.prototype.getFirstWeekStartDate = function () {
        return new Date(this.year, this.month, 1 - this.getFirstMonthDayWeekPosition());
    };
    CalendarWeeks.prototype.getLastWeekEndDate = function () {
        return new Date(this.year, this.month + 1, 6 - this.getLastMonthDayWeekPosition());
    };
    return CalendarWeeks;
}());
exports.CalendarWeeks = CalendarWeeks;
//# sourceMappingURL=CalendarWeeks.js.map